"use client";

import * as React from "react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { cn } from "@/lib/utils";
import { Quote } from "lucide-react";
const testimonials = [{
  quote: "Wenn ich jetzt anfange mich aufzuregen oder nachts aufwache, dann spüre ich meinen Atem. Dann kommt die Gelassenheit. Und ich schlafe einfach wieder ein.",
  author: "Hanna B.",
  role: "Achtsamkeitskurs"
}, {
  quote: "Mein Körper wusste eigentlich schon längst, was Sache war. Was ich wollte. Und was ich nicht mehr wollte.\xA0",
  author: "Markus S.",
  role: "Einzelcoaching"
}, {
  quote: "Endlich jemand, der mir nicht erzählt, was mit mir nicht stimmt. Sondern wie ich es schaffe, wieder mehr Stimmigkeit herzustellen. Nicht trotz meiner Symptome. Sondern mit meinen Symptomen.",
  author: "Sarah L.",
  role: "Achtsamkeitskurs"
}, {
  quote: "Claudia strahlt so viel Authentizität und Offenheit aus, und so etwas Positives. Da dachte ich, hier kann bin ich gut aufgehoben.",
  author: "Christian V.",
  role: "Krisenberatung"
}];
export default function StimmenUnsererPartner() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  const handleDotClick = (index: number) => {
    if (api) {
      api.scrollTo(index);
    }
  };
  return <section data-section-id="28089" id="stimmen-des-vertrauens" className="bg-accent text-foreground py-32 px-4 md:px-8 overflow-hidden relative">
      <div className="max-w-5xl mx-auto">
        <Carousel setApi={setApi} className="w-full">
          <CarouselContent>
            {testimonials.map((item, index) => <CarouselItem key={index} data-index={index}>
                <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                  {}
                  <div className="w-full flex justify-start mb-6 opacity-40">
                    <Quote className="w-12 h-12 md:w-16 md:h-16 text-primary rotate-180 fill-primary/10" />
                  </div>

                  {}
                  <blockquote className="relative max-w-4xl mx-auto">
                    <p className="text-2xl md:text-4xl font-default italic text-foreground leading-relaxed tracking-tight">
                      {item.quote}
                    </p>
                  </blockquote>

                  {}
                  <div className="w-full flex justify-end mt-6 opacity-40">
                    <Quote className="w-12 h-12 md:w-16 md:h-16 text-primary fill-primary/10" />
                  </div>

                  {}
                  <div className="mt-12 space-y-1">
                    <cite className="not-italic text-sm font-sans font-bold text-foreground block tracking-wide">
                      {item.author}
                    </cite>
                    <span className="text-sm text-muted-foreground block">
                      {item.role}
                    </span>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
        </Carousel>

        {}
        <div className="flex justify-center gap-4 mt-16">
          {Array.from({
          length: count
        }).map((_, index) => <button key={index} data-index={index} onClick={() => handleDotClick(index)} className={cn("h-2.5 w-2.5 rounded-full transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-accent", current === index ? "bg-primary scale-125 shadow-sm" : "bg-muted-foreground/20 hover:bg-muted-foreground/40")} aria-label={`Go to slide ${index + 1}`} aria-current={current === index ? "true" : "false"} />)}
        </div>
      </div>
    </section>;
}